/**
 * Google Analytics event tracking utilities
 */

// Extend the global Window interface to include dataLayer
declare global {
	interface Window {
		dataLayer: any[]
	}
}

/**
 * Sends a search event to Google Analytics
 * This should be triggered when a user performs a search
 *
 * @param searchQuery - The search query string
 */
export const sendSearchEvent = (searchQuery: string): void => {
	if (typeof window !== 'undefined' && searchQuery.trim().length > 0) {
		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'search',
			searchString: searchQuery,
			currentPageUrl: window.location.pathname
		})
	}
}

/**
 * Sends a search result click event to Google Analytics
 * This should be triggered when a user clicks on a search result
 *
 * @param searchQuery - The search query that led to this result
 * @param destinationUrl - The URL the user will be navigated to
 */
export const sendSearchResultClickEvent = (searchQuery: string, destinationUrl: string): void => {
	if (typeof window !== 'undefined' && searchQuery.trim().length > 0) {
		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'search_result_click',
			searchString: searchQuery,
			destinationUrl: destinationUrl,
			currentPageUrl: window.location.pathname
		})
	}
}
